import React, { Component, useState, useEffect } from 'react';
import {Modal, Button} from 'react-bootstrap'
import "./ModalOk.css"


export function ModalOk(props){
    const [smShow, setSmShow] = useState(false);

    useEffect(function(){
        setSmShow(true)
    })

    
    return(
        <>
         <Modal
        size="sm"
        show={smShow}
        centered
        onHide={() => setSmShow(false)}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            {props.tittle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="buttons">
          <div className="buttonYN">
              <Button size="lg" variant="success" onClick={e=> props.ok()}>
                Ok
              </Button>
          </div>
          </Modal.Body>
      </Modal>
        </>
    )
}

